import { useEffect, useState } from "react";
import { socket } from "./socket";
import { API_URL } from "./config";

function App() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/orders`)
      .then(res => res.json())
      .then(data => setOrders(data));

    socket.on("order:new", (order) => {
      setOrders(prev => [order, ...prev]);
    });

    socket.on("order:update", (updated) => {
      setOrders(prev =>
        prev.map(o =>
          o.id === updated.id ? { ...o, status: updated.status } : o
        )
      );
    });

    return () => {
      socket.off("order:new");
      socket.off("order:update");
    };
  }, []);

  return (
    <div style={{
      padding: 30,
      fontFamily: "Arial",
      background: "#0f172a",
      minHeight: "100vh",
      color: "white"
    }}>
      <h1>📦 LINE Dashboard</h1>

      {orders.map(o => (
        <div key={o.id} style={{
          padding: 15,
          marginBottom: 10,
          background: o.status === "done" ? "#14532d" : "#1e293b",
          borderRadius: 10
        }}>
          <div><b>TEXT:</b> {o.text}</div>
          <div><b>STATUS:</b> {o.status}</div>
        </div>
      ))}
    </div>
  );
}

export default App;